import React from 'react';
import { useTranslator, useAppContext } from '@front-activerse/common-components';
import { Container, Row, Col, Spinner } from 'reactstrap';
import Layout from '../../Layout/Layout';
import TrackerTimeline from './components/TrackerTimeline';
import TitleBar from '../../Layout/TitleBar';
import { Link } from 'react-router-dom';

const TrackerPlaceholder: React.FC<{ date: string; loading: boolean }> = ({ date, loading }) => {
  const { t } = useTranslator();

  const {
    images: { gearIcon },
  } = useAppContext();

  return (
    <Layout>
      <TitleBar showBackBtn={true}>
        {t('tracker.details.navbarTitle')}
        <div className="title-bar-icons">
          <Link to="/tracker/settings" className="ps-2">
            <img src={gearIcon} alt="" style={{ width: '32px', height: '32px' }} />
          </Link>
        </div>
      </TitleBar>

      <div className="page-template-tracker">
        <Container className="py-md-4">
          <Row>
            <Col xl={{ size: 10, offset: 1 }}>
              <div className="page-container">
                <TrackerTimeline date={date} />
                <div className="full-height3">
                  <div className="loader-wrapper no-fixed">
                    <Spinner color="primary">{t('loading.message')}</Spinner>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

export default TrackerPlaceholder;
